// import { useEffect, useState } from "react";
// import axios from "axios";
// import { useTranslation } from "react-i18next";
// import { licenceService } from "../../../../src/services/licence.service";
// import InputWidth from "../../../components/inputs/InputWidth";
// import SelectBoxWithRequest from "../../../components/SelectBoxWithRequest";
// import { Button, Select } from "antd";

// const InstallationDetailList = ({ data }) => {

//     const [myFilter, setMyFilter] = useState({});
//     const [ListData, setListData] = useState([]);
//     const { t } = useTranslation();
//     const [moduleList, setModuleList] = useState([]);

//     const InfoRow = ({ label, value }) => (
//         <div className="flex">
//             <span className="w-32 font-medium">{label}:</span>
//             <span className="text-gray-700">{value || "-"}</span>
//         </div>
//     );

//     const formatDate = (dateStr) => {
//         if (!dateStr) return "-";
//         const date = new Date(dateStr);
//         const day = String(date.getDate()).padStart(2, '0');
//         const month = String(date.getMonth() + 1).padStart(2, '0');
//         const year = date.getFullYear();
//         return `${day}.${month}.${year}`;
//     };


//     const formatToTwoDecimals = (value) => {
//         if (value === null || value === undefined || value === "") return "-";

//         const num = parseFloat(value);
//         if (isNaN(num)) return value;

//         return num.toFixed(2);
//     };

//     return (
//         <>
//             <div className="border border-gray-300 rounded-lg bg-white shadow p-4 mb-6 py-4">
//                 {data?.installList?.length > 0 ? (
//                     <div className="space-y-6">
//                         {data.installList.map((install, index) => (
//                             <div key={install.id || index} className="p-4 border rounded-md">
//                                 <h3 className="font-semibold text-lg text-gray-800 mb-4">{install.name}</h3>

//                                 <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 text-sm text-gray-700">
//                                     {/* Sütun 1 */}
//                                     <div className="space-y-2">
//                                         <InfoRow label={t("PC Type")} value={install.database} />
//                                         <InfoRow label={t("PC Name")} value={install.databaseUniversalKey} />
//                                         <InfoRow label={t("User Name")} value={install.ipAddress} />
//                                         <InfoRow
//                                             label={t("System (version)")}
//                                             value={formatToTwoDecimals(install.version)}
//                                         />

//                                     </div>

//                                     {/* Sütun 2 */}
//                                     <div className="space-y-2">
//                                         <InfoRow label={t("IP")} value={install.language} />
//                                         <InfoRow label={t("Installation Number")} value={formatDate(install.firstUseDate)} />
//                                         <InfoRow label={t("Activation Code")} value={formatDate(install.lastUseDate)} />
//                                         <InfoRow label={t("Ins. Date")} value={install.sectorCode} />
//                                     </div>

//                                     {/* Sütun 3 */}
//                                     <div className="space-y-2">
//                                         <InfoRow label={t("Last Use")} value={install.name} />
//                                         <InfoRow label={t("VERSION_USE")} value={install.city} />
//                                     </div>
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 ) : (
//                     <p className="text-sm text-gray-500">{t("No installations found.")}</p>
//                 )}
//             </div>

//         </>
//     );
// };

// export default InstallationDetailList;

// import { useTranslation } from "react-i18next";
// import iconPc from "../../../../src/icons-svg/icon_pc.svg";
// /** Label + value satırı (value sola yaslı) */
// const InfoRow = ({ label, value }) => (
//   <div className="flex items-center gap-3 transition-colors duration-300">
//     <span className="w-32 font-medium text-gray-900 dark:!text-white">
//       {label}:
//     </span>
//     <span className="text-gray-700 dark:!text-white break-words text-left">
//       {value || "-"}
//     </span>
//   </div>
// );


// /** 2 ondalık gösterim */
// const formatToTwoDecimals = (val) => {
//   if (val === null || val === undefined || val === "") return "-";
//   const num = parseFloat(val);
//   return Number.isNaN(num) ? val : num.toFixed(2);
// };

// /** GG.AA.YYYY */
// const formatDate = (dateStr) => {
//   if (!dateStr) return "-";
//   const d = new Date(dateStr);
//   const dd = String(d.getDate()).padStart(2, "0");
//   const mm = String(d.getMonth() + 1).padStart(2, "0");
//   const yyyy = d.getFullYear();
//   return `${dd}.${mm}.${yyyy}`;
// };

// const InstallationDetailList = ({ data }) => {
//   const { t } = useTranslation();
//   const list = Array.isArray(data?.installList) ? data.installList : [];

//   return (
//     <div
//       className="
//     rounded-lg shadow p-4 mb-6
//     bg-white dark:bg-gray-900
//     text-gray-800
//     dark:[&_*]:!text-white
//     transition-colors
//     border border-gray-200 dark:border-white
//   "
//     >
//       {data?.installList?.length > 0 ? (
//         <div className="space-y-5">
//           {data.installList.map((install, index) => (
//             <div
//               key={install.id || index}
//               className="p-5 rounded-md border border-gray-200 dark:border-gray-800"
//             >
//               <h3 className="font-semibold text-lg mb-4 break-words">
//                 {install.name}
//               </h3>

//               {/* ✅ Responsive wrapper */}
//               <div
//                 className="
//               w-full grid gap-4 items-start
//               grid-cols-1
//               md:grid-cols-[48px_1fr]
//               xl:grid-cols-[56px_1fr]
//             "
//               >
//                 {/* Sol: icon */}
//                 <div className="flex items-start">
//                   <img
//                     src={iconPc}
//                     alt={t("PC Type")}
//                     title={t("PC Type")}
//                     className="w-6 h-6 cursor-default opacity-90 hover:opacity-100"
//                   />
//                 </div>

//                 {/* Sağ: içerik */}
//                 <div className="min-w-0 w-full">
//                   <div
//                     className="
//                   grid w-full gap-6 text-sm
//                   grid-cols-1
//                   sm:grid-cols-2
//                   xl:grid-cols-3
//                 "
//                   >
//                     <div className="space-y-1 min-w-0 w-full">
//                       <InfoRow label={t("PC Name")} value={install.computerName} />
//                       <InfoRow label={t("User Name")} value={install.userName} />
//                       <InfoRow
//                         label={t("System (version)")}
//                         value={install.operatingSystemVersion}
//                       />
//                     </div>

//                     <div className="space-y-1 min-w-0 w-full">
//                       <InfoRow label={t("IP")} value={install.installIp} />
//                       <InfoRow label={t("Installation Number")} value={install.installNo} />
//                       <InfoRow label={t("Activation Code")} value={install.activation} />
//                     </div>

//                     <div className="space-y-1 min-w-0 w-full">
//                       <InfoRow label={t("Ins. Date")} value={formatDate(install.installDate)} />
//                       <InfoRow label={t("Last Use")} value={formatDate(install.lastUseDate)} />
//                       <InfoRow label={t("VERSION_USE")} value={install.version} />
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       ) : (
//         <p className="text-sm text-gray-600 dark:!text-white">
//           {t("No installations found.")}
//         </p>
//       )}
//     </div>

//   );
// };

// export default InstallationDetailList;

// import { useTranslation } from "react-i18next";
// import iconPc from "../../../../src/icons-svg/icon_pc.svg";

// // const InfoRow = ({ label, value }) => (
// //   <div className="flex items-start gap-3 min-w-0 flex-wrap transition-colors duration-300">
// //     {/* Label alanı aynı kalsın */}
// //     <span className="w-32 shrink-0 font-medium text-gray-900 dark:!text-white">
// //       {label}:
// //     </span>

// //     {/* Value: sığmazsa alt satıra insin */}
// //     <span className="flex-1 min-w-0 text-gray-700 dark:!text-white break-words whitespace-normal text-left">
// //       {value || ""}
// //     </span>
// //   </div>
// // );

// // /** 2 ondalık gösterim */
// // const formatToTwoDecimals = (val) => {
// //   if (val === null || val === undefined || val === "") return "-";
// //   const num = parseFloat(val);
// //   return Number.isNaN(num) ? val : num.toFixed(2);
// // };

// // /** GG.AA.YYYY */
// // const formatDate = (dateStr) => {
// //   if (!dateStr) return "-";
// //   const d = new Date(dateStr);
// //   const dd = String(d.getDate()).padStart(2, "0");
// //   const mm = String(d.getMonth() + 1).padStart(2, "0");
// //   const yyyy = d.getFullYear();
// //   return `${dd}.${mm}.${yyyy}`;
// // };

// // const InstallationDetailList = ({ data }) => {
// //   const { t } = useTranslation();
// //   const list = Array.isArray(data?.installList) ? data.installList : [];

// //   return (
// //     // ✅ 1. dış çerçeve kaldırıldı (border/shadow/bg yok)
// //     <div className="mb-6">
// //       {list.length > 0 ? (
// //         <div className="space-y-6">
// //           {list.map((install, index) => (
// //             <div
// //               key={install.id || index}
// //               className="p-5 rounded-md border border-gray-200 dark:border-gray-200"
// //             >
// //               <h3 className="font-semibold text-lg mb-4 break-words text-gray-900 dark:text-gray-100">
// //                 {install.name}
// //               </h3>

// //               {/* ✅ Responsive wrapper aynı sırada */}
// //               <div
// //                 className="
// //                   w-full grid gap-4 items-start
// //                   grid-cols-1
// //                   md:grid-cols-[48px_1fr]
// //                   xl:grid-cols-[150px_1fr]
// //                 "
// //               >
// //                 {/* Sol: icon */}
// //                 <div className="flex items-start">
// //                   <img
// //                     src={iconPc}
// //                     alt={t("PC Type")}
// //                     title={t("PC Type")}
// //                     className="w-6 h-6 cursor-default opacity-90 hover:opacity-100"
// //                   />
// //                 </div>

// //                 {/* Sağ: içerik */}
// //                 <div className="min-w-0 w-full">
// //                   <div
// //                     className="
// //                       grid w-full gap-6 text-sm
// //                       grid-cols-1
// //                       sm:grid-cols-2
// //                       xl:grid-cols-3
// //                     "
// //                   >
// //                     <div className="space-y-1 min-w-0 w-full">
// //                       <InfoRow label={t("PC Name")} value={install.computerName} />
// //                       <InfoRow label={t("User Name")} value={install.userName} />
// //                       <InfoRow
// //                         label={t("System (version)")}
// //                         value={install.operatingSystemVersion}
// //                       />
// //                     </div>

// //                     <div className="space-y-1 min-w-0 w-full">
// //                       <InfoRow label={t("IP")} value={install.installIp} />
// //                       <InfoRow label={t("Installation Number")} value={install.installNo} />
// //                       <InfoRow label={t("Activation Code")} value={install.activation} />
// //                     </div>

// //                     <div className="space-y-1 min-w-0 w-full">
// //                       <InfoRow label={t("Ins. Date")} value={formatDate(install.installDate)} />
// //                       <InfoRow label={t("Last Use")} value={formatDate(install.lastUseDate)} />
// //                       <InfoRow label={t("Version Use")} value={install.version} />
// //                     </div>
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>
// //           ))}
// //         </div>
// //       ) : (
// //         <p className="text-sm text-gray-600 dark:!text-white">
// //           {t("No installations found.")}
// //         </p>
// //       )}
// //     </div>
// //   );
// // };

// // export default InstallationDetailList;

// const InfoRow = ({ label, value }) => (
//   <div className="flex items-start gap-3 min-w-0 flex-wrap transition-colors duration-300">
//     <span className="w-32 shrink-0 font-medium text-gray-800 dark:text-white">
//       {label}:
//     </span>

//     <span className="flex-1 min-w-0 text-gray-700 dark:text-white break-words whitespace-normal text-left">
//       {value || ""}
//     </span>
//   </div>
// );

// const formatDate = (dateStr) => {
//   if (!dateStr) return "-";
//   const d = new Date(dateStr);
//   const dd = String(d.getDate()).padStart(2, "0");
//   const mm = String(d.getMonth() + 1).padStart(2, "0");
//   const yyyy = d.getFullYear();
//   return `${dd}.${mm}.${yyyy}`;
// };

// const InstallationDetailList = ({ data }) => {
//   const { t } = useTranslation();
//   const list = Array.isArray(data?.installList) ? data.installList : [];

//   return (
//     <div className="mb-6">
//       {list.length > 0 ? (
//         <div className="space-y-6">
//           {list.map((install, index) => (
//             <div
//               key={install.id || index}
//               className="
//                 p-5 rounded-md
//                 border border-gray-300
//                 bg-white text-gray-800
//                 dark:bg-gray-600 dark:text-white
//                 dark:border-gray-400
//                 transition-colors duration-300
//               "
//             >
//               <h3 className="font-semibold text-lg mb-4 break-words text-gray-800 dark:text-white">
//                 {install.name}
//               </h3>

//               <div
//                 className="
//                   w-full grid gap-4 items-start
//                   grid-cols-1
//                   md:grid-cols-[48px_1fr]
//                   xl:grid-cols-[150px_1fr]
//                 "
//               >
//                 <div className="flex items-start">
//                   <img
//                     src={iconPc}
//                     alt={t("PC Type")}
//                     title={t("PC Type")}
//                     className="w-6 h-6 cursor-default opacity-90 hover:opacity-100"
//                   />
//                 </div>

//                 <div className="min-w-0 w-full">
//                   <div
//                     className="
//                       grid w-full gap-6 text-sm
//                       grid-cols-1
//                       sm:grid-cols-2
//                       xl:grid-cols-3
//                     "
//                   >
//                     <div className="space-y-1 min-w-0 w-full">
//                       <InfoRow label={t("PC Name")} value={install.computerName} />
//                       <InfoRow label={t("User Name")} value={install.userName} />
//                       <InfoRow
//                         label={t("System (version)")}
//                         value={install.operatingSystemVersion}
//                       />
//                     </div>

//                     <div className="space-y-1 min-w-0 w-full">
//                       <InfoRow label={t("IP")} value={install.installIp} />
//                       <InfoRow label={t("Installation Number")} value={install.installNo} />
//                       <InfoRow label={t("Activation Code")} value={install.activation} />
//                     </div>

//                     <div className="space-y-1 min-w-0 w-full">
//                       <InfoRow label={t("Ins. Date")} value={formatDate(install.installDate)} />
//                       <InfoRow label={t("Last Use")} value={formatDate(install.lastUseDate)} />
//                       <InfoRow label={t("Version Use")} value={install.version} />
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       ) : (
//         <p className="text-sm text-gray-500 dark:text-white">
//           {t("No installations found.")}
//         </p>
//       )}
//     </div>
//   );
// };

// export default InstallationDetailList;
import React from "react";
import { useTranslation } from "react-i18next";
import iconPc from "../../../../src/icons-svg/icon_pc.svg";

/** GG.AA.YYYY */
const formatDate = (dateStr) => {
  if (!dateStr) return "-";
  const d = new Date(dateStr);
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}.${mm}.${yyyy}`;
};

// Satır bileşeni (label solda, value hemen yanında; sığmazsa alt satır)
const InfoRow = ({ label, value }) => (
  <div className="flex items-start gap-3 min-w-0 flex-wrap transition-colors duration-300">
    <span className="w-32 shrink-0 font-medium text-gray-800 dark:!text-white">
      {label}:
    </span>

    <span className="flex-1 min-w-0 text-gray-700 dark:!text-white break-words whitespace-normal text-left">
      {value ?? ""}
    </span>
  </div>
);

const InstallationDetailList = ({ data }) => {
  const { t } = useTranslation();
  const list = Array.isArray(data?.installList) ? data.installList : [];

  return (
    // ✅ dış çerçeve yok
    <div className="mb-6">
      {list.length > 0 ? (
        <div className="space-y-6">
          {list.map((install, index) => (
            <div
              key={install?.id ?? index}
              className="
                p-5 rounded-md
                border border-gray-300
                bg-white
                text-gray-800
                dark:bg-gray-600
                dark:border-gray-400
                dark:text-white
              "
            >
              {/* ✅ dark modda kesin beyaz */}
              <h3 className="font-semibold text-lg mb-4 break-words text-gray-800 dark:!text-white">
                {install?.name ?? "-"}
              </h3>

              <div
                className="
                  w-full grid gap-4 items-start
                  grid-cols-1
                  md:grid-cols-[48px_1fr]
                  xl:grid-cols-[150px_1fr]
                "
              >
                {/* Sol: icon */}
                <div className="flex items-start">
                  <img
                    src={iconPc}
                    alt={t("PC Type")}
                    title={t("PC Type")}
                    className="w-6 h-6 cursor-default opacity-90 hover:opacity-100"
                  />
                </div>

                {/* Sağ: içerik */}
                <div className="min-w-0 w-full">
                  <div
                    className="
                      grid w-full gap-6 text-sm
                      grid-cols-1
                      sm:grid-cols-2
                      xl:grid-cols-3
                    "
                  >
                    <div className="space-y-1 min-w-0 w-full">
                      <InfoRow label={t("PC Name")} value={install?.computerName ?? "-"} />
                      <InfoRow label={t("User Name")} value={install?.userName ?? "-"} />
                      <InfoRow
                        label={t("System (version)")}
                        value={install?.operatingSystemVersion ?? "-"}
                      />
                    </div>

                    <div className="space-y-1 min-w-0 w-full">
                      <InfoRow label={t("IP")} value={install?.installIp ?? "-"} />
                      <InfoRow
                        label={t("Installation Number")}
                        value={install?.installNo ?? "-"}
                      />
                      <InfoRow
                        label={t("Activation Code")}
                        value={install?.activation ?? "-"}
                      />
                    </div>

                    <div className="space-y-1 min-w-0 w-full">
                      <InfoRow
                        label={t("Ins. Date")}
                        value={formatDate(install?.installDate)}
                      />
                      <InfoRow
                        label={t("Last Use")}
                        value={formatDate(install?.lastUseDate)}
                      />
                      <InfoRow
                        label={t("Version Use")}
                        value={install?.version ?? "-"}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-sm text-gray-600 dark:!text-white">
          {t("No installations found.")}
        </p>
      )}
    </div>
  );
};

export default InstallationDetailList;
